export default __webpack_public_path__ + "static/media/card-12.4f0afec8.png";